import { CheckIcon } from "@heroicons/react/24/outline";
import { cx } from "../../../utils/classnames";
import { FilterOption } from "./reservationFilters";

interface FilterOptionListProps {
  options: FilterOption[];
  selected: string[];
  // Radio rows for single choice, checkbox rows for multiple.
  multiple?: boolean;
  onToggle: (value: string) => void;
}

const FilterOptionList = ({ options, selected, multiple, onToggle }: FilterOptionListProps) => (
  <ul role="listbox" aria-multiselectable={multiple} className="flex flex-col gap-0.5">
    {options.map((option) => {
      const checked = selected.includes(option.value);
      return (
        <li key={option.value}>
          <button
            type="button"
            role="option"
            aria-selected={checked}
            onClick={() => onToggle(option.value)}
            className={cx([
              "flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm",
              checked ? "bg-primary/5 font-medium" : "hover:bg-gray-50"
            ])}
          >
            <span
              className={cx([
                "flex h-4 w-4 shrink-0 items-center justify-center border",
                multiple ? "rounded" : "rounded-full",
                checked ? "border-primary bg-primary text-white" : "border-gray-300"
              ])}
            >
              {checked && <CheckIcon className="w-3 h-3" strokeWidth={3} />}
            </span>
            {option.label}
          </button>
        </li>
      );
    })}
  </ul>
);

export default FilterOptionList;
